export default __webpack_public_path__ + "assets/bxAnalyse.baa12f9f.svg";